import React from 'react';
import injectSheet from 'react-jss'
import {cdn, getAsset} from '../../helpers/cdn'
import {center} from "../../style/globalStyles";
import {LINKS} from "../../../constants";
import Sidebar from './Sidebar.jsx'


const style = {
    appBar: {
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'black',
        height: '55px',
        width: '100%',
        zIndex: '2000',
        display: 'inline-flex',
        flexDirection: 'row'
    },
    logoContainer: Object.assign(center(), {
        height: '100%',
        flexShrink: 1,
        marginLeft: '10px'
    }),
    logo: {
        height: '50px'
    },
    linksContainer: {
        height: '100%',
        display: 'flex',
        flex: 1,
        listStyle: 'none',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        marginRight: '40px',
        '@media (max-width: 650px)': {
            display:'none'
        }
    },
    link: {
        padding: '7px',
        margin: '5px',
        borderRadius: '16px',
        transition: 'background-color 0.5s',
        '&:hover': {
            backgroundColor: 'rgba(66,66,66,0.8)'
        }
    },
    linkHref: {
        color: 'white',
        textDecoration: 'none',
        fontSize: '14px'
    },
    burgerContainer: Object.assign(center(), {
        paddingRight: '12px',
        cursor: 'pointer',
        position: 'absolute',
        right: '0',
        top: '0',
        height: '100%',
        display:'none',
        '@media (max-width: 650px)': {
            display:'inherit'
        }
    })
};

class AppBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isSideBarOpen: false,
            AppBarLinks: [
                {url: LINKS.TEAM, text: 'Team'},
                {url: LINKS.BLOG, text: 'Blog'}
            ]
        };
        this.toggleSideBar = this.toggleSideBar.bind(this)
    }

    toggleSideBar() {
        this.setState({
            isSideBarOpen: !this.state.isSideBarOpen
        })
    }

    render() {
        const {classes} = this.props;
        const {isSideBarOpen, AppBarLinks} = this.state;

        return (
            <div>
                <div className={classes.appBar}>

                    <div className={classes.logoContainer}>
                        <a href="https://streamelements.com/">
                            <img className={classes.logo} src="https://cdn.streamelements.com/assets/logos/SE_home_page_logo.svg" alt="StreamElements"/>
                        </a>
                    </div>

                    <ul className={classes.linksContainer}>
                        {AppBarLinks.map((link,index) => {
                            return <li key={index} className={classes.link}>
                                <a className={classes.linkHref} href={link.url}>
                                    {link.text}
                                </a>
                            </li>
                        })}
                    </ul>

                    <div onClick={this.toggleSideBar} className={classes.burgerContainer}>
                        <img src={getAsset('icons/burger.svg')} alt=""/>
                    </div>

                </div>

                {isSideBarOpen &&
                <Sidebar closeSidebar={this.toggleSideBar}/>
                }
            </div>
        )
    }
}

export default injectSheet(style)(AppBar)



// WEBPACK FOOTER //
// ./src/app/components/AppBar/index.jsx